const meta = {
    'meta.name': 'English',
    'meta.short': 'en_EN',
};

export default meta;
